exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!font-awesome/css/font-awesome.min.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!simple-line-icons/css/simple-line-icons.css"), "");

// module
exports.push([module.id, "$fa-font-path:\"~font-awesome/fonts/\";$simple-line-font-path:\"~simple-line-icons/fonts/\";", "", {"version":3,"sources":["/home/davidwolff/projects/scms/secure-customer-messaging-ui/src/App.vue"],"names":[],"mappings":"AAqCE,qCAAqC,AAErC,mDAAoD","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  /*\nMust be separate from styles below\nFrom CoreUI-Vue\n*/\n  $fa-font-path:\"~font-awesome/fonts/\";\n@import \"~font-awesome/css/font-awesome.min.css\";\n  $simple-line-font-path: \"~simple-line-icons/fonts/\";\n@import \"~simple-line-icons/css/simple-line-icons.css\";\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5897f20b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = QDTc
// module chunks = 1